/**
 * "Switch to NestPlot" promo banner used on the homepage + per-vertical
 * landing pages.
 *
 * Lives in its own section — visually separate from the trial-signup
 * form in the hero — so it reads as the migration story, not as a
 * second signup form. (Until 2026-11-01 this carried the year-free
 * launch pilot; that offer is closed. The hero form is the standard
 * 30-day trial; this banner points at /pilot, now the migration page.)
 */
import { Link } from "react-router-dom";

import { Btn } from "../../lib/Btn";
import { Icon } from "../../lib/Icon";
import { Slats } from "../../lib/Slats";

export function PilotPromoSection() {
  return (
    <section className="bg-accent text-on-accent border-y border-line">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8 py-10 lg:py-12">
        <Slats color="var(--on-accent)" opacity={0.45} height={10} />
        <div className="mt-5 grid lg:grid-cols-[1.4fr_1fr] gap-8 items-center">
          <div>
            <div className="font-mono text-[11px] tracking-[0.16em] uppercase opacity-80">
              Switching software?
            </div>
            <h2 className="font-display font-black text-[28px] lg:text-[36px] tracking-[-0.02em] mt-2 leading-[1.1]">
              We run the migration
              <br />
              with you — included.
            </h2>
            <p className="mt-4 max-w-[560px] leading-relaxed opacity-90">
              Leaving AppFolio, Yardi, storEDGE, SiteLink, DockMaster, or a
              spreadsheet? The NestPlot team moves your roster, leases, and
              balances over with you — included on every plan, no setup fee.
              Start on a 30-day free trial, no card.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 items-center">
              <Link to="/pilot">
                <Btn
                  kind="secondary"
                  size="md"
                  iconRight={<Icon name="arrow-right" size={14} />}
                >
                  Plan my migration
                </Btn>
              </Link>
              <span className="font-mono text-[11px] tracking-[0.12em] uppercase opacity-80">
                Or start your trial above
              </span>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 text-center">
            <Stat label="Trial" value="30 days" />
            <Stat label="Setup fee" value="$0" />
            <Stat label="Migration" value="Included" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <div className="font-mono text-[10px] tracking-[0.14em] uppercase opacity-75">
        {label}
      </div>
      <div className="font-display font-black text-[26px] lg:text-[30px] tracking-[-0.02em] mt-1">
        {value}
      </div>
    </div>
  );
}
